export default "__VITE_ASSET__D8WfC8ph__"